
import { useRouter } from 'next/router'
import Link from 'next/link'
import { ReactNode, AnchorHTMLAttributes, useMemo } from 'react'
import React from 'react'
import { useWPP } from './WPPContext'

interface CustomLinkProps extends AnchorHTMLAttributes<HTMLAnchorElement> {
    href: string
    children: ReactNode
    openWpp?: boolean
}

const CustomLink: React.FC<CustomLinkProps> = ({
    href,
    children,
    openWpp,
    ...props
}) => {
    const router = useRouter()
    const { setOpenWpp } = useWPP()
    const combinedHref = useMemo(() => {
        const [baseURL, hashFragment] = href.split('#')

        // Extrair os parâmetros de consulta atuais
        const currentParams = new URLSearchParams(
            router.query as Record<string, string>,
        )

        // Remover o parâmetro choice se existir
        currentParams.delete('choice')
        currentParams.delete('pageName')

        // Extrair os parâmetros da href
        const [path, queryString] = baseURL.split('?')
        const newParams = new URLSearchParams(queryString || '')

        // Atualizar currentParams com newParams (isso substituirá os parâmetros existentes)
        newParams.forEach((value, key) => {
            currentParams.set(key, value)
        })

        // Construir a URL final com os parâmetros de consulta atualizados
        const queryStringFinal = currentParams.toString()
        let hrefWithParams = queryStringFinal
            ? `${path}?${queryStringFinal}`
            : path

        if (hashFragment) {
            hrefWithParams += `#${hashFragment}`
        }

        return hrefWithParams
    }, [href, router.query])

    const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
        if (openWpp) {
            e.preventDefault()
            setOpenWpp(true)
        }
        // Executa o onClick original se existir
        props.onClick?.(e)
    }

    // Remove o onClick das props para não duplicar a chamada
    const { onClick, ...otherProps } = props

    return (
        <Link
            onClick={handleClick}
            href={openWpp ? '#' : combinedHref}
            passHref
            {...otherProps}
        >
            {children}
        </Link>
    )
}

export default React.memo(CustomLink)
